import React, { useState, useEffect } from 'react'
import './style.css'
import Button from '../CtaButton'
import useIsMobile from '../../hooks/useIsMobile'
import { truncateWords } from '../../utils/textUtils'
import ServicesBannerForm from '../services-banner-from/ServicesBannerForm'

const ChatbotBanner = ({ shortHeading, mainHeading, description, buttonText, bannerImage, icons }) => {

    const isMobile = useIsMobile();
    const [isLoading, setIsLoading] = useState(true);

    const [videoLoaded, setVideoLoaded] = useState(false);

    useEffect(() => {
        // Preload the video manually
        const video = document.createElement('video');
        video.src = "/images/why-us-section/chatbot-banner.mp4";
        video.preload = "auto";
        video.oncanplaythrough = () => {
            setVideoLoaded(true); // Video is ready to play
        };
    }, []);

    return (
        <>
            <div className="services-page-banner-main-box">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-7 col-md-12 service-banner-text-area">
                            <div className="services-page-banner-text-box">
                                <h1 className='low-top-heading'>{shortHeading}</h1>
                                <p className="capital-main-heading" dangerouslySetInnerHTML={{ __html: mainHeading }} />
                                <p className="description-text banner-description-text" dangerouslySetInnerHTML={{ __html: isMobile ? truncateWords(description, 10) : description }}></p>
                                {/* <div className="mt-4">
                                    <Button text={buttonText} link='/contact-us' />
                                </div> */}
                                {icons ? <div className="services-banner-rating-icon">
                                    {icons?.map((image, index) => {
                                        return <a href="#" target='_blank' key={index}>
                                            <img src={image} width={90} alt="" />
                                        </a>
                                    })}
                                </div> : <div className="services-banner-rating-icon">
                                    <a href="https://www.youtube.com/watch?v=LDmv2CrkM1c" target='_blank'>
                                        <img src="/images/new-Payoneer.svg" className='payoneer-image-service-banner' width={160} alt="Best Web Development Company Awarded by Payoneer" />
                                    </a>
                                    <a href="https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights" target='_blank'>
                                        <img src="/images/new-clutch.svg" className='clutch-image-service-banner' width={120} alt="Bitsclan IT Solutions Trusted by Clutch" />
                                    </a>
                                </div>}
                            </div>
                        </div>

                        <div className="col-xl-5 col-lg-5 col-md-12 service-banner-text-area p-xl-0 p-lg-0 mt-0 mt-lg-0">
                            <div className="chatbot-page-banner-image">

                                <video
                                    src="/images/why-us-section/chatbot-banner.mp4"
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    preload='auto'
                                    className="object-cover w-100"
                                    onLoadedData={() => setIsLoading(false)}
                                />
                                {isLoading && (
                                    // <div className="video-placeholder">
                                    //     <i class="fa-solid fa-spinner fa-spin"></i>
                                    // </div>
                                    <div className="chatbot-image-box">
                                        <img src="/images/why-us-section/chatbot-banner.png" alt="" />
                                    </div>
                                )}
                            </div>

                            <div className="foam-button-chatbot-pages">
                                <ServicesBannerForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChatbotBanner